<template>
	<div ref="carouselContainer" class="carousel-container overflow-hidden">
		<div
			ref="carouselContent"
			class="flex tab:flex-col gap-32 *:whitespace-nowrap tab:h-[var(--carousel-height)]"
			:class="{ 'carousel-move': isCarousel, 'carousel-static': !isCarousel }"
		>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
			<div ref="carouselInitial" class="flex tab:flex-col gap-32 *:whitespace-nowrap">
				<slot></slot>
			</div>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
			<template v-if="isCarousel">
				<slot></slot>
			</template>
		</div>
	</div>
</template>

<script setup>
import { ref, onMounted, onBeforeUnmount } from "vue";
import { onResize } from "@js/throttle.js"

const isCarousel = ref(false);
const carouselContainer = ref(null);
const carouselContent = ref(null);
const carouselInitial = ref(null);

const checkCarousel = async () => {
	if (carouselContainer.value && carouselContent.value &&	carouselInitial.value) {
		const initialHeight = carouselInitial.value.getBoundingClientRect().height;
		const initialWidth = carouselInitial.value.getBoundingClientRect().width;

		carouselContent.value.style.setProperty("--carousel-height", `${initialHeight}px`);
		carouselContent.value.style.setProperty("--carousel-width", `${initialWidth}px`);
		isCarousel.value = true;

		/* calculate animation speed dynamically so it is uniform regardless of the number of items in the carousel */
		const ySpeed = 30; /* tweak this number to change carousel speed - higher = faster, lower = slower */
		const xSpeed = 60; /* tweak this number to change carousel speed - higher = faster, lower = slower */
		carouselContent.value.style.setProperty("--carousel-y-duration", `${initialHeight / ySpeed}s`);
		carouselContent.value.style.setProperty("--carousel-x-duration", `${initialWidth / xSpeed}s`);
	}
};

onMounted(() => {
	checkCarousel();
	onResize(checkCarousel);
});

onBeforeUnmount(() => {
	window.removeEventListener("resize", checkCarousel);
});
</script>

<style scoped>
.carousel-move {
	animation: carousel-x var(--carousel-x-duration) linear infinite;

	@screen tab {
		animation: carousel-y var(--carousel-y-duration) linear infinite;
	}
}

@keyframes carousel-x {
	0% {
		transform: translateX(0%);
	}
	100% {
		transform: translateX(calc(-1 * var(--carousel-width) - theme(spacing.32)));
	}
}

@keyframes carousel-y {
	0% {
		transform: translateY(0%);
	}
	100% {
		transform: translateY(calc(-1 * var(--carousel-height) - theme(spacing.32)));
	}
}

.carousel-container {
	mask-image: linear-gradient(to right, transparent, black 32px, black calc(100% - 32px), transparent);

	@screen tab {
		mask-image: linear-gradient(to bottom, transparent, black 64px, black calc(100% - 64px), transparent);
	}
}
</style>
